import React, { useState, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import Projects from "@/pages/Projects";
import ProjectDetail from "@/pages/ProjectDetail";
import ChatAssistant from "@/pages/ChatAssistant";
import DiaryPage from "@/pages/DiaryPage";
import LoginPage from "@/pages/LoginPage";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

function App() {
  const [authed, setAuthed] = useState(false);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("tf_token");
    if (token) {
      axios
        .get(`${BACKEND_URL}/api/auth/verify`, { params: { token } })
        .then(() => setAuthed(true))
        .catch(() => {
          localStorage.removeItem("tf_token");
          localStorage.removeItem("tf_user");
        })
        .finally(() => setChecking(false));
    } else {
      setChecking(false);
    }
  }, []);

  const handleLogin = () => setAuthed(true);

  const handleLogout = () => {
    localStorage.removeItem("tf_token");
    localStorage.removeItem("tf_user");
    setAuthed(false);
  };

  if (checking) {
    return (
      <div className="min-h-screen bg-slate-50 flex items-center justify-center">
        <div className="text-center">
          <span className="text-2xl font-extrabold tracking-tight text-[#003057]">Testflow</span>
          <p className="text-xs text-slate-400 mt-2">Loading...</p>
        </div>
      </div>
    );
  }

  if (!authed) {
    return (
      <>
        <LoginPage onLogin={handleLogin} />
        <Toaster position="top-right" richColors />
      </>
    );
  }

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route element={<Layout onLogout={handleLogout} />}>
            <Route index element={<Dashboard />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/projects/:projectId" element={<ProjectDetail />} />
            <Route path="/diary" element={<DiaryPage />} />
            <Route path="/chat" element={<ChatAssistant />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
